import React from "react";
import "./ExternalLinkModal.css";
import RegionContext from "../../../RegionContext";

const ExternalLinkModal = ({show, onClose, onProceed}) => {
const region = React.useContext(RegionContext);

    if (!show) {
        return null; // Don't render the modal if it's not shown
    }

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <button className="modal-close" onClick={onClose}>
                    &times;
                </button>
                <p className="modal-text">{region === "FR" ? "Vous allez être redirigé vers un site internet externe." : "You will be redirected to an external website."}</p>
                <br/>
                <button className="modal-proceed-button" onClick={onProceed}>
                     {region === "FR" ? "Poursuivre" : "Proceed"}
                </button>
            </div>
        </div>
    );
};
export default ExternalLinkModal;
